import {IBytecode} from "../interfaces/IBytecode";
import {Geodesic} from "../Tools/Geodesic";
import {IPoint} from "../interfaces/IPoint";
import {Triangulation} from "../Tools/Triangulation";
import {ILegEvaluation} from "../interfaces/ILegEvaluation";
import {ITimedStop} from "../interfaces/ITimedStop";
import {Log} from "../Tools/Log";
import {IProjectedTimedStop} from "../interfaces/IProjectedTimedStop";
import {IProjectedDirection} from "../interfaces/IProjectedDirection";
import {IDirection} from "../interfaces/IDirection";


export class LegHandler {

    // @ts-ignore
    private metersLen: number;
    private readonly pointList: IPoint[];
    // @ts-ignore
    private metersOffset: number = 0;   // The distance from origin of this leg.
    // @ts-ignore
    private indexOffset: number; // The offset of this piston.


    public firstIndex: number;
    public lastIndex: number;
    private directions: IDirection[] = [];
    private projectedDirections: IProjectedDirection[] = [];
    private timedStops: ITimedStop[] = [];
    private projectedTimedStops: IProjectedTimedStop[] = [];
    private triangulation: Triangulation;
    private distancesArray: number[] = [];
    // @ts-ignore
    private length: number;
    private legIndex: number;   //The index of the current leg.

    constructor(bytecode: IBytecode, timedStops: ITimedStop[], index: number, refPointList: IPoint[], directions:IDirection[]) {
        this.indexOffset = bytecode.legs[index].firstIndexOnRawTriangulation;
        this.metersOffset = bytecode.legs[index].distanceFromOrigin;
        this.firstIndex = bytecode.legs[index].firstIndexOnRawTriangulation;
        this.lastIndex = bytecode.legs[index].lastIndexOnRawTriangulation;
        this.length = bytecode.legs[index].length;
        this.pointList = refPointList.slice(this.firstIndex, this.lastIndex + 1);
        this.metersLen = Geodesic.pointListMetersLen(this.pointList);
        this.triangulation = new Triangulation(this.pointList);
        this.legIndex = index;
        this.computeDistancesArray();

        //Extracting contained stops.
        for(let stopIndex of bytecode.legs[index].containedStops) {
            let timedStop = timedStops.find(e => stopIndex.stopId === e.id);
            if(timedStop) {
                this.timedStops.push(timedStop);
            } else {
                Log.die("Timed stop in leg " + index + " with id " + stopIndex + " is missing from the supplied timed stops list.");
            }
        }

        this.projectSelfStops();

        //Extracting contained directions.
        for(let dirIndex of bytecode.legs[index].containedDirections) {
            if(!dirIndex.unSure) {   //We avoid unsure directions.
                let direction = directions.find(e => dirIndex.directionId === e.id);
                if(direction !== undefined) {
                    this.directions.push(direction);
                } else {
                    Log.die("Direction in leg " + index + " with id " + dirIndex.directionId + " is missing from the supplied timed direction list.");
                }
            }

        }

        this.projectSelfDirections();
    }

    evaluatePoint(point: IPoint) : ILegEvaluation {
        let projection = this.triangulation.interpolatePoint(point);        // Make a triangulation for this leg
        let distance = this.distancesArray[projection.localRefIndex];       // Distance array of each point of this leg
        if(projection.relativePosition === "AFTER") {
            // We should add the distance between projection and closest point
            distance = distance + Geodesic.metersBetween(projection.refPoint, projection.interpolation);
        } else if (projection.relativePosition === "BEFORE") {
            // ... Or remove it
            distance = distance - Geodesic.metersBetween(projection.refPoint, projection.interpolation);
        }
        // Or keep it if in place (do nothing)

        // let gap = Geodesic.metersBetween(point, this.pointList[projection.localRefIndex]); //Distance between projection and provided point

        return {
            gap: projection.iGap,
            distance: distance + this.metersOffset,
            placement: projection.relativePosition,
            indexOnShape: projection.localRefIndex + this.indexOffset,
            heading: 0,
            projection: projection.interpolation,
            triangulation: projection,
            leg: this.legIndex
        };
    }

    /**
     * Compute the array of distances of each point on the leg.
     * @private
     */
    private computeDistancesArray() {
        this.distancesArray = [];
        let totalLen:number = 0;
        for(let i = 0; i < this.pointList.length - 1; i++) {
            this.distancesArray.push(totalLen);
            totalLen = totalLen + Geodesic.metersBetween(this.pointList[i], this.pointList[i+1]);
        }
        this.distancesArray.push(totalLen);
    }

    private projectSelfStops() {
        for(let i = 0; i < this.timedStops.length; i++) {
            let projection =this.evaluatePoint(this.timedStops[i].point);
            let pts:IProjectedTimedStop = {
                arrivalTime : this.timedStops[i].arrivalTime,
                departureTime: this.timedStops[i].departureTime,
                sequence: this.timedStops[i].sequence,
                id: this.timedStops[i].id,
                point: this.timedStops[i].point,
                projection: projection,
                distanceFromOrigin: projection.distance, // Leg offset is already included.
            }

            this.projectedTimedStops.push(pts);
        }
        return this.projectedTimedStops;
    }

    public getSelfStops() : IProjectedTimedStop[] {
        return this.projectedTimedStops;
    }

    private projectSelfDirections() {
        for(let i = 0; i < this.directions.length; i++) {
            let projection =this.evaluatePoint(this.directions[i].point);
            let pd:IProjectedDirection = {
                id: this.directions[i].id,
                point: this.directions[i].point,
                projection: projection,
                distanceFromOrigin: projection.distance, // Leg offset is already included.
            }

            this.projectedDirections.push(pd);
        }
        return this.projectedDirections;
    }

    public getSelfDirections() : IProjectedDirection[] {
        return this.projectedDirections;
    }





}
